export default "<div class=\"spinner-container no-bg\">\n  <mat-spinner class=\"spiner\"></mat-spinner>\n</div>"